import axios from "axios";

export const getEventData = (hash) => axios.get(`/api/v2/share-links/${hash}`);
